export default "__VITE_ASSET__977d7616__"